import * as React from 'react';
import cn from 'classnames';

import './index.scss';

import * as iconEye from './static/img/eye.svg';
import * as iconEyeClosed from './static/img/eye-closed.svg';

interface Props {
  className?: string;
  isPlainText: boolean;
  onClick: () => void;
}

export const Eye: React.FC<Props> = ({ className, isPlainText, onClick }) => (
  <img
    className={cn('password-field-eye', className)}
    role="button"
    onClick={onClick}
    src={isPlainText ? iconEye : iconEyeClosed}
    alt="show/hide password"
  />
);
